import DateUtils from "@/helpers/DateUtils.js";
export default class Notification {
	constructor({added_on, body, event, key, status, title, to, date}) {
		this.added_on = added_on ? added_on : DateUtils.toDefaultDateTime(new Date());
		this.body = body || {};
		this.event = event || "";
		this.status = status || "";
		this.title = title || "";
		this.to = to || "";
		this.date = date || 0;
		if (key) {
			this.key = key;
		}
	}
}
